import { map } from 'rxjs';
import { OutfitService } from '../outfit.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AuthService } from 'src/app/shared/services/auth.service';
import { QatchComponent } from 'src/app/components/qatch.component';
import { SharedModule } from 'src/app/shared/modules/shared.module';
import { UikitListComponent } from 'src/app/shared/modules/uikit-list/uikit-list.component';
import { IListItemMeta } from 'src/app/shared/modules/uikit-list/uikit-list-item/uikit-list-item.component';
import { MESSAGE_TYPE, ShareWithFriendsService } from 'src/app/shared/services/share-with-friends.service';
import { SeoService } from 'src/app/shared/services/seo.service';

@Component({
    selector: 'outfits',
    templateUrl: './outfits.component.html',
    styleUrls: ['./outfits.component.scss'],
    standalone: true,
    imports: [
        SharedModule,
        UikitListComponent
    ]
})
export class OutfitsComponent extends QatchComponent implements OnInit {
    productMeta: IListItemMeta = {
        type: 'outfits-product',
        page: 'outfits',
        pageType: '',
        pageOwnerId: null,
        uiTaggingKey: 'outfits',
        displayKey: 'imageUrl',
        showOverlay: ()=>{ return true},
        showLinkButton: true,
        fixedOverlay: true,
        showTitle: true
    };
    pageTitle: string = `Outfits`;
    noOutfit = false;
    userId;
    authorId;
    
    constructor(
        private router: Router,
        private outfitService: OutfitService,
        private activatedRoute: ActivatedRoute,
        override readonly authService: AuthService,
        override readonly deviceService: DeviceDetectorService,
        private shareWithFriendsService: ShareWithFriendsService,
        private seoService: SeoService,
    ) {
        super(deviceService, authService);
        this.userId = this.activatedRoute.snapshot.parent.params['userId'];
    }

    override ngOnInit(): void {
        super.ngOnInit();
    }

    override postAuth(user) {
        if(!this.userId) {
            this.updateUserDetail(user.first_name);
        }
    }

    copyLink(item: any) {
        const { title, uuid, author } = item;
        const usrId = author.id;
        const nTitle = this.outfitService.isUuid(title)? '' : title;
        
        const link = `${window.location.origin}/users/${usrId}/outfits/${uuid}`
        this.shareWithFriendsService.share(link, MESSAGE_TYPE.OUTFIT, nTitle)
    }

    updateUserDetail(name) {
        this.pageTitle = name ? `${name}’s Outfits` : 'Outfits';
    }

    fetchProducts(query) {
        return this.outfitService.getOutfitsByUserId(this.userId, { pageNumber: query.page, pageSize: 50 }, {}, {})
        .pipe(map(res => {
            if (res?.data?.length) {
                for (const outfit of res.data) {
                    if(outfit.imageUrl.startsWith('uploads')) {
                        outfit.imageUrl = outfit.imageUrl.replace(/\//g, '%2F');
                        outfit.imageUrl = `https://firebasestorage.googleapis.com/v0/b/qatchcode-production.appspot.com/o/${outfit.imageUrl}?alt=media`;
                    }
                }
                if (!this.isLoggedIn && res?.data[0].author) {
                    const author  = res.data[0].author;
                    this.authorId = author.id;
                    this.updateUserDetail(author.name);
                }
                if (query.initialLoad) {
                    this.seoService.updateOutfit(this.router.url, res.data[0], res.data);
                }
            } else {
                if (query.page === 1) {
                    this.noOutfit = true;
                }
            }
            return res;
        }));
    }

    getCurrentRoute() {
        return this.isLoggedIn ? 'internal/outfits': `users/${this.userId}/outfits`;
    }

    openOutfitMaker(event) {
        this.router.navigate([`${this.getCurrentRoute()}/${event.uuid}`]);
    }
}
